import type {
  ListOverview,
  WorkflowPerformance,
  ChannelStat,
  ChannelPerformanceResponse,
  WorkflowStatsResponse,
  DashboardOverview,
} from "./types";
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient } from "@shared/api/clients/apiClientFactory";

export const DashboardApi = {
  overview: async (utilityId: string): Promise<DashboardOverview> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "dashboard/new/overview",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );

    const response = await communicationApiClient.get(url);
    return response.data.result;
  },

  listOverview: async (utilityId: string): Promise<ListOverview> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "dashboard/list-overview",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );

    const response = await communicationApiClient.get(url);
    return response.data.result;
  },

  channelPerformance: async (
    utilityId: string
  ): Promise<ChannelPerformanceResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "dashboard/channel-performance",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );

    const response = await communicationApiClient.get(url);
    return response.data.result;
  },

  workflowPerformance: async (
    utilityId: string
  ): Promise<WorkflowPerformance> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "dashboard/workflow-performance",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );

    const response = await communicationApiClient.get(url);
    return response.data.result;
  },

  workflowStats: async (utilityId: string): Promise<WorkflowStatsResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "dashboard/workflow-stats",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );

    const response = await communicationApiClient.get(url);
    return response.data;
  },

  channelStats: async (utilityId: string): Promise<ChannelStat> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "dashboard/channel-stats",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );

    const response = await communicationApiClient.get(url);
    return response.data.result;
  },
};
